export default function getRecaptchaToken(): Promise<string> {
  return new Promise(resolve => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.NEXT_PUBLIC_RECAPTCHA_KEY, {
          action: 'submit'
        })
        .then(resolve);
    });
  });
}
